import React, { useEffect, useRef, useState } from 'react';
import { groupwareApi } from './api';
import { setAuth } from './auth';

export default function LoginPage({ onLogin }) {
  const [employeeId, setEmployeeId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const idRef = useRef(null);

  useEffect(() => {
    setTimeout(() => idRef.current?.focus?.(), 0);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');

    if (!employeeId.trim()) {
      setError('사번 또는 ID를 입력하세요.');
      return;
    }
    if (!password) {
      setError('비밀번호를 입력하세요.');
      return;
    }

    setLoading(true);
    try {
      const res = await groupwareApi.post('/login', {
        employee_id: employeeId.trim(),
        password,
      });
      const data = res.data || {};
      if (!data.token || !data.user) {
        setError('로그인 응답에 토큰 또는 사용자 정보가 없습니다.');
        return;
      }
      setAuth(data.token, data.user);
      onLogin?.();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.error || '로그인에 실패했습니다.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hc-login-page">
      <div className="hc-login-card">
        <div className="hc-brand-row">
          <div className="hc-logo-mark">H</div>
          <div>
            <h1>Hansero Chat</h1>
            <p>사내 채팅 서비스</p>
          </div>
        </div>

        <form onSubmit={submit} className="hc-login-form">
          <label>
            <span>사번 / ID</span>
            <input
              ref={idRef}
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              autoComplete="username"
              inputMode="text"
            />
          </label>
          <label>
            <span>비밀번호</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>

          {error ? <div className="hc-login-error">{error}</div> : null}

          <button type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="hc-login-note">
          기존 그룹웨어 계정으로 로그인합니다.
        </div>
      </div>
    </div>
  );
}
